import { render, staticRenderFns } from "./appConfig.vue?vue&type=template&id=4cbbca14&scoped=true"
import script from "./appConfig.vue?vue&type=script&lang=js"
export * from "./appConfig.vue?vue&type=script&lang=js"
import style0 from "./appConfig.vue?vue&type=style&index=0&id=4cbbca14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbbca14",
  null
  
)

export default component.exports